<template>
  <div class="routerInfo">

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <font-awesome-icon class="mainblock-icon" style="color: red" icon="newspaper"></font-awesome-icon>
            <a  class="mainblock-label">考试列表</a>
          </div>

        </div>
        <el-tabs style="margin-left: 2rem" v-model="examStatus" @tab-click="changeStatus">
          <el-tab-pane label="待考" name="0" ></el-tab-pane>
          <el-tab-pane label="已考" name="1"></el-tab-pane>
        </el-tabs>
        <div class="container-body">
          <div class="party-right">
            <div class="exam-block">

                <div class="w-exam-li" v-for="exam in examList" @click="toDetail(exam)">
                  <el-row>
                    <el-col :span="2">
                      <div class="w-exam-logo"></div>
                    </el-col>
                    <el-col :span="10">
                      <div class="w-exam-content">
                        <div class="w-exam-name">{{exam.examName}}</div>
                        <div class="w-exam-time">{{formattedTime(exam.startTime)}}-{{formattedTime(exam.endTime)}}</div>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="w-exam-score">
                        <span class="w-exam-score2" v-if="exam.examStatus>0">{{exam.correctScore}}分</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="w-exam-status">
                          <el-button type="danger" v-if="examStatus == 0 && exam.examStatus == 0">{{exam.examStatus | examStatus}}</el-button>
                          <el-button type="warning" v-if="examStatus == 0 && exam.examStatus != 0">{{exam.examStatus | examStatus}}</el-button>
                          <el-button type="primary" v-if="examStatus != 0 && exam.examStatus == 0">{{exam.examStatus | examedStatus}}</el-button>
                          <el-button type="warning" v-if="examStatus != 0 && exam.examStatus != 0">{{exam.examStatus | examedStatus}}</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
  @import "../../assets/less/variables.less";
  @import "../../assets/less/mySearch.less";
  @import "../../assets/less/style.less";
</style>

<script type="text/ecmascript-6">
  import viewFunction from "../../assets/js/viewFunction";
  import { mapState, mapGetters ,mapMutations} from 'vuex'
  import { Loading } from 'element-ui'
  const moment = require('moment')
  export default {
    name: 'Training',
    inject:['check'],
    data(){
      return {
        examList: [],
        loadLoading: false,
        examStatus: 0,
      }
    },
    filters: {
      examStatus(val) {
        if (val ==0){
          return '未交卷'
        }
        return '已交卷'
      },
      examedStatus(val) {
        if (val ==0){
          return '已缺考'
        }
        return '已交卷'
      }
    },
    mounted() {
      this.examStatus = 0

      this.findAllData()
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),
      ...mapGetters({
        navigationList: 'navs'
      })
    },
    methods:{
      formattedTime(time) {
        return moment(time).format('YYYY-MM-DD HH:mm:ss');
      },
      findAllData(){
        let url = '/api/onlineExamUser/findWaitingExamList'
        if (this.examStatus == 0){
          url = '/api/onlineExamUser/findWaitingExamList'
        }else {
          url = '/api/onlineExamUser/findExamedList'
        }
        let params = {
          userId: this.user.userId,
          answerType : '2',
          pageNum:1,
          pageSize:10
        }
        this.loadLoading = true
        let that = this
        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
          that.loadLoading= false
          that.examList = res.data
        }))
      },
      changeStatus(){
        this.findAllData()
      },
      toDetail(exam){
        let endTime = moment(exam.endTime)
        let now = Date()
        if (endTime.isAfter(now)){
          if (exam.examStatus ==0){
            this.$router.push({
              path:'/Examing',
              query:{
                examId:exam.examId,
                examTime: exam.examTime,
                onlineExamUserId: exam.onlineExamUserId
              }
            })
          }else {
            this.$router.push({
              path:'/ExamResult',
              query:{
                onlineExamUserId: exam.onlineExamUserId
              }
            })
          }

        }else {
          if (exam.examStatus ==0){
              this.$message.error('您已缺考，无法查询答题记录')
          }else {
            this.$router.push({
              path:'/ExamResult',
              query:{
                onlineExamUserId: exam.onlineExamUserId
              }
            })
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/learn/ExamList.vue